<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" [ngClass]="{'mobile-modal-content': responsive.isMobileSignal()}" [id]="getId()">
    <ng-template [ngTemplateOutlet]="template"></ng-template>
  </div>
</div>
